module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "abriefculinaryhistory"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006abriefculinaryhistory"
    }
  }, [_vm._v("A Brief Culinary History")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "acookstouroftheland"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007acookstouroftheland"
    }
  }, [_vm._v("A Cook’s Tour of The Land")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "themoroccanpantry"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/008themoroccanpantry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moroccan Pantry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/009part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread and Savory Pastries")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phyllo Rolls Stuffed with Milky Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phyllo Triangles Stuffed with Fresh Cheese Briouats Bil Jben")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Pastilla")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layered Berber Flatbread Rghayif")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Olive, Walnut, and Onion Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Round Bread Khobz")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups and Legumes")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harira")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beet Soup with Ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Split Pea Soup with Cumin and Paprika Bessara")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soupy Lentils Âades")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Beans in Tomato Sauce Loubia")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Street Food")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Fritters Maakouda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chickpeas In Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Djemaa El Fna Snails in Broth Babbouche")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Marinated Sardine Pairs Serdine Chrak")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Sardines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Marinated Chicken Brochettes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/029chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Spicy Kefta Brochettes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh and Cooked Salads")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumbers in Sweet Marinade with Oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Olives Zeytun M’charmel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grated Carrot and Orange Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/034chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot and Cumin Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Eggplant, Tomato, and Garlic Salad Zaâlouk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cooked Zucchini And Tomato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame-Grilled Green Pepper and Fresh Tomato Salad Tchektchouka")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Sweet Butternut Squash Salad with Cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beet Salad with Green Onions and Fresh Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meats")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/041chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb Tagine with Sweetened Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb Tagine with Oranges, Saffron, and Candied Orange Peel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salty-Sweet Glazed Lamb with Almonds and Raisins M’rouzia")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb with Garlic, Cumin, and Coriander Mkila")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Lamb with Cumin Mechoui")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kid Tagine with Dried Figs and Thyme")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Veal Shank Tagine with Caramelized Prunes and Apricots")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veal Shank Tagine with Pears")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veal Shank Tagine with Peas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kefta Meatball Tagine in Tomato Sauce with Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/051chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marrakech Tangia Tangia")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/052part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs and Poultry")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/053chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berber Omelet Tagine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/054chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rif Mountain Omelet with Wild Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/055chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date-And-Almond-Stuffed Poussins with Sweet Vermicelli")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/056chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Tagine with Preserved Lemons and Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/057chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Tagine with French Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/058chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Tagine with Caramelized Tomato Compote Djaj M’assal")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/059chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken in Buttery Saffron-Onion Sauce with Almonds Djaj Khdra Bil Louz")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/060chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Essaouira-Style Chicken Bathed in Whisked Eggs Djaj Souiri")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/061part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish and Shellfish")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/062chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mussels in Tomato Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/063chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mussel Tagine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/064chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Shrimp Tagine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep-Fried Calamari with Tomato Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/066chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Fish Brochettes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/067chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Balls in Tomato Sauce Serdine Kwari")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/068chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Atlas Trout Stuffed with Grated Carrots and Fresh Bay Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/069chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Tagine with Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/070chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Monkfish Tagine with Caramelized Onion and Raisin Tfaya")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/071part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Couscous")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/072chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Couscous Grains: Two Methods of Preparing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/073chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berber Barley Couscous with Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/074chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Couscous With Caramelized Onion and Raisin Tfaya Kuskus Tfaya")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/075chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Vegetable Couscous Kuskus Baydawi")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/076chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Couscous with Pumpkin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/077chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Couscous Kuskus Hut")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/078part9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweets and Desserts")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/079chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stewed Sweet Spiced Pears")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/080chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oranges with Orange Flower Water and Cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/081chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Slices with Anise, Ginger, and Golden Raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/082chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Dates")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/083chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honeyed Phyllo Triangles Stuffed with Almonds Briouats Bil Louz")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/084chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Pastry with Orange Flower Custard and Almonds Pastilla Jouhara")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/085chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Pudding with Sliced Almonds M’halbi")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/086chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ground Almond, Honey, and Argan Oil Dip Amlou")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/087chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghriba Walnut Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/088chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Baked Anise and Sesame Seed Cookies Fekkas Beldi")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/089chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clementine Sponge Cake with Clementine Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/090chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Couscous Seffa")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/091part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinks")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/092chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiced Coffee Qehwa M’attar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/093chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Tea Atay Bil Naânaâ")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/094chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saffron Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/095chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milky Tea with Oregano, Aniseed, and Lavender Kandra")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/096chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Milk with Orange Flower Water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/097chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Cucumber and Orange Juice with Oregano")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "selectedbibliography"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/098selectedbibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/099acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/100index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0dcaf74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/103toc.vue
// module id = 66
// module chunks = 0